import JobFullView from './JobFullView';
import JobsPage from './JobsPage';
import JobApplication from './elements/JobApplication';
import JobPreferences from './JobPreferences';
import JobApplications from './JobApplicationsPage';
import SavedSearchPage from './SavedSearchPage';
import JobFavourites from './JobsSavedPage';
import JobsLayout from './JobsLayout';
import MyJobsPage from './MyJobsPage';

export {
    JobsPage,
    JobFullView,
    JobApplication,
    JobPreferences,
    JobApplications,
    SavedSearchPage,
    JobFavourites,
    JobsLayout,
    MyJobsPage
}



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/index.js